export default function PhoneNumberSpanComponent(props: { phoneNo: string }) {
    return (
        props.phoneNo.match(/\d{2}/g)?.map((v, index) => {
            return <span key={index}>{v}</span>
        })
    )
}
